<div class="spinner-wrapper">
  <wlm-spinner [fromOverlay]="true" (selfClose)="onSelfClose()"></wlm-spinner>
</div>
